<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/xllh/jxjqrc.png" alt="" />
            <div class="technological-process">
                <div class="zcjj">
                    <img class="top" style="height: 1.12rem" src="./../assets/imgs/xllh/rcgyysq_zcjj.png" alt="" />
                    <div class="content">
                        <div class="des">
                            成都以城市之名礼贤才志士，来蓉应聘急需紧缺岗位的青年人才，可凭面试通知申领急需紧缺人才专属礼包，享受地铁公交、文化旅游、移动通讯等人才服务。
                        </div>
                    </div>
                </div>
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/xllh/rcgysq_sqdx.png" alt="" />
                    <div class="content">
                        <div class="title">
                            <span class="hollow-cricle"></span>
                            来蓉应聘成都市急需紧缺岗位的青年人才
                        </div>
                        <div class="des mar-t2">
                            （扫下方二维码了解“成都城市猎头行动计划”首批急需紧缺岗位）
                            <div class="mar-t4">
                                <div class="cdcslt">
                                    <img src="./../assets/imgs/xllh/jxjqrc_cdcslt_code.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="lbnr">
                    <img class="top" src="./../assets/imgs/xllh/jxjqrc_lbnr.png" alt="" />
                    <div class="content">
                        <div class="des">
                            礼包包含成都特色景点定制门票、定制天府通公交卡、充电宝、笔记本等等（根据该批次礼包内容有所调整，以实物为准）。
                        </div>
                        <div class="lbnr-detail mar-t3">
                            <img src="./../assets/imgs/xllh/lbnr_detail.png" alt="" />
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/xllh/rpqnrcyz_bllc.png" alt="" />
                    <div class="content">
                        <div class="title">
                            <span class="hollow-cricle"></span>（一）通过“人才礼包”平台申领
                        </div>
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">申请二维码</div>
                                </div>
                                <div class="line-content">
                                    扫描“急需紧缺人才礼包”专属二维码进行申请;
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">选择岗位</div>
                                </div>
                                <div class="line-content">
                                    选择应聘或入职岗位;
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">填写信息</div>
                                </div>
                                <div class="line-content">
                                    填写申请人的基本信息;
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">上传资料</div>
                                </div>
                                <div class="line-content">
                                    上传面试通知书或入职OFFER，学生证或在校应届证明;
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">5</div>
                                    <div class="line-title">等待审核</div>
                                </div>
                                <div class="line-content">
                                    审核专员后台审核，通过后按预约时间在成都人才综合服务中心领取;
                                </div>
                            </div>
                        </div>
                        <div class="title mar-t4">
                            <span class="hollow-cricle"></span>（二）通过“蓉漂青年人才驿站”平台 申领
                        </div>
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">申请入住</div>
                                </div>
                                <div class="line-content">
                                    进入“蓉漂青年人才驿站”平台申请入住;
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">填写资料</div>
                                </div>
                                <div class="line-content">
                                    填写申请入住所需基本信息，勾选“急需紧缺岗位”选项;
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">进行申领</div>
                                </div>
                                <div class="line-content">
                                    同意申领人才礼包;
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">等待审核</div>
                                </div>
                                <div class="line-content">
                                    审核专员后台审核，通过后按预约时间在所申请入住的“蓉漂青年人才驿站”领取。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/label/contact4.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-61889591">028-61889591</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            中共成都市委组织部（市委人才办）
                        </div>
                    </div>
                </div>
                <div class="sqsj">
                    <div class="jxjqrc-sqsj">
                        <img src="./../assets/imgs/xllh/jxjqrc_sqsj_code.png" alt="" />
                    </div>
                    <div class="jxjqrc-rpqnrcyz">
                        <img src="./../assets/imgs/xllh/jxjqrc_rpqnrcyz_code.png" alt="" />
                    </div>
                </div>

                <!-- <bottom
                            phone="028-61889591"
                            unit="中共成都市委组织部（市委人才办）"
                        ></bottom> -->
            </div>
        </section>
        <call phone="028-61889591" site="http://cdtalents.cn:9997/talent_h5/#/talentPackage"></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        // bottom,
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;
    padding-bottom: 0.1rem;

    .top-img {
        width: 7.47rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .zcjj {
            .top {
                width: 6.68rem;
                height: 2.12rem;
            }

            .content {
                width: 6.68rem;
                background: #ffffff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
            line-height: 0.44rem;


                .title {
                    font-size: 0.34rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    line-height: 0.44rem;
                    text-align: left;
                    margin-top: 0.16rem;
                }
            }
        }

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem 0.3rem;
                    text-align: left;
                    line-height: 0.44rem;
                    position: relative;

                    .cdcslt {
                        width: 6.03rem;
                        height: 1.94rem;
                        background-image: url("./../assets/imgs/xllh/jxjqrc_cdcslt.png");
                        background-size: 100% 100%;
                        background-repeat: no-repeat;

                        img {
                            width: 1.94rem;
                            height: 1.94rem;
                        }
                    }

                    .describe {
                        background: linear-gradient(180deg,
                                #ffffff 0%,
                                rgba(255, 255, 255, 0) 100%);
                        border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                        opacity: 1;
                        padding: 0.33rem 0.33rem 0 0.15rem;

                        .num {
                            min-width: 0.39rem;
                            height: 0.39rem;
                            background: #739bfe;
                            color: #ffffff;
                            display: inline-flex;
                            border-radius: 50%;
                            justify-content: center;
                            align-items: center;
                            margin-right: 0.14rem;
                        }
                    }
                }
            }
        }

        .lbnr {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .lbnr-detail {
                    width: 6.1rem;
                    height: 5.24rem;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem 0.3rem;
                    position: relative;

                    .title-img {
                        position: absolute;
                        left: 50%;
                        top: 0rem;
                        width: 4.46rem;
                        height: 0.67rem;
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    line-height: 0.44rem;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                            line-height: 0.46rem;
                        }

                        .line-top {
                            display: flex;

                            .line-num {
                                min-width: 0.39rem;
                                height: 0.39rem;
                                line-height: 0.39rem;
                                background: #739bfe;
                                color: #ffffff;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                align-content: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }

                    .des-item {
                        font-size: 0.26rem;
                        font-weight: 500;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        border-left: 0.02rem dashed #739bfe;
                        padding-bottom: 0.55rem;

                        .cdrcwewm {
                            width: 5.51rem;
                            height: 1.43rem;
                            margin-top: 0.16rem;
                        }
                    }

                    .describe-item {
                        font-size: 0.26rem;
                        font-weight: 500;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        word-break: break-all;
                    }
                }
            }
        }

        .sqsj {
            width: 6.85rem;
            height: 5.2rem;
            background: #ffffff;
            border-radius: 0.26rem 0.26rem 0.26rem 0.26rem;
            margin: 0.3rem auto 0;
            padding-top: 0.3rem;
            box-sizing: border-box;

            .jxjqrc-sqsj {
                width: 6.22em;
                height: 2.08rem;
                margin: 0 auto;
                background-image: url("./../assets/imgs/xllh/jxjqrc_sqsj.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                text-align: left;

                img {
                    width: 2.08rem;
                    height: 2.08rem;
                }
            }

            .jxjqrc-rpqnrcyz {
                width: 6.22em;
                height: 2.08rem;
                margin: 0.3rem auto 0;
                background-image: url("./../assets/imgs/xllh/jxjqrc_rpqnrcyz.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                text-align: left;

                img {
                    width: 2.08rem;
                    height: 2.08rem;
                }
            }
        }

        .zrdw {
            font-size: 0.24rem;
            font-weight: 500;
            color: #97a9d9;
            margin-top: 0.16rem;
        }

        .zxdh {
            font-size: 0.24rem;
            font-weight: 500;
            color: #97a9d9;
            line-height: 0.28rem;
        }

        .phone-list {
            margin-top: 0.36rem;

            img {
                width: 6.85rem;
                height: 14.93rem;
            }
        }
    }
}
</style>
